package link.erpango.quip.domain.entities

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DNotificationSettingsRequest(
    @SerialName("notifications_enabled") val notificationsEnabled: Boolean,
    @SerialName("itv_notifications_enabled") val itvNotificationsEnabled: Boolean,
    @SerialName("revision_notifications_enabled") val revisionNotificationsEnabled: Boolean,
    @SerialName("spare_part_notifications_enabled") val sparePartNotificationsEnabled: Boolean
)
